/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Preference,
    PreferenceFromJSON,
    PreferenceFromJSONTyped,
    PreferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface PreferenceRule
 */
export interface PreferenceRule {
    /**
     * 
     * @type {string}
     * @memberof PreferenceRule
     */
    preferenceRuleId?: string;
    /**
     * 
     * @type {Preference}
     * @memberof PreferenceRule
     */
    preference?: Preference;
    /**
     * 
     * @type {string}
     * @memberof PreferenceRule
     */
    preferenceName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PreferenceRule
     */
    brand?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PreferenceRule
     */
    brandName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PreferenceRule
     */
    market?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PreferenceRule
     */
    marketName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PreferenceRule
     */
    allowEdit?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PreferenceRule
     */
    channel?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PreferenceRule
     */
    channelName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PreferenceRule
     */
    providerId?: string;
    /**
     * 
     * @type {string}
     * @memberof PreferenceRule
     */
    providerName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PreferenceRule
     */
    enabled?: boolean | null;
    /**
     * 
     * @type {object}
     * @memberof PreferenceRule
     */
    effectiveDateFrom?: object | null;
    /**
     * 
     * @type {object}
     * @memberof PreferenceRule
     */
    effectiveDateTo?: object | null;
    /**
     * 
     * @type {string}
     * @memberof PreferenceRule
     */
    updatedBy?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof PreferenceRule
     */
    updatedDate?: Date;
}

export function PreferenceRuleFromJSON(json: any): PreferenceRule {
    return PreferenceRuleFromJSONTyped(json, false);
}

export function PreferenceRuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): PreferenceRule {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'preferenceRuleId': !exists(json, 'preferenceRuleId') ? undefined : json['preferenceRuleId'],
        'preference': !exists(json, 'preference') ? undefined : PreferenceFromJSON(json['preference']),
        'preferenceName': !exists(json, 'preferenceName') ? undefined : json['preferenceName'],
        'brand': !exists(json, 'brand') ? undefined : json['brand'],
        'brandName': !exists(json, 'brandName') ? undefined : json['brandName'],
        'market': !exists(json, 'market') ? undefined : json['market'],
        'marketName': !exists(json, 'marketName') ? undefined : json['marketName'],
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
        'channel': !exists(json, 'channel') ? undefined : json['channel'],
        'channelName': !exists(json, 'channelName') ? undefined : json['channelName'],
        'providerId': !exists(json, 'providerId') ? undefined : json['providerId'],
        'providerName': !exists(json, 'providerName') ? undefined : json['providerName'],
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'effectiveDateFrom': !exists(json, 'effectiveDateFrom') ? undefined : json['effectiveDateFrom'],
        'effectiveDateTo': !exists(json, 'effectiveDateTo') ? undefined : json['effectiveDateTo'],
        'updatedBy': !exists(json, 'updatedBy') ? undefined : json['updatedBy'],
        'updatedDate': !exists(json, 'updatedDate') ? undefined : (new Date(json['updatedDate'])),
    };
}

export function PreferenceRuleToJSON(value?: PreferenceRule | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'preferenceRuleId': value.preferenceRuleId,
        'preference': PreferenceToJSON(value.preference),
        'preferenceName': value.preferenceName,
        'brand': value.brand,
        'brandName': value.brandName,
        'market': value.market,
        'marketName': value.marketName,
        'allowEdit': value.allowEdit,
        'channel': value.channel,
        'channelName': value.channelName,
        'providerId': value.providerId,
        'providerName': value.providerName,
        'enabled': value.enabled,
        'effectiveDateFrom': value.effectiveDateFrom,
        'effectiveDateTo': value.effectiveDateTo,
        'updatedBy': value.updatedBy,
        'updatedDate': value.updatedDate === undefined ? undefined : (value.updatedDate.toISOString()),
    };
}


